import React from 'react';

export default function LudiSelectionCard({ selected, onClick, title, subtitle, children, className = '' }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`w-full text-left p-ludi-4 rounded-ludi-md border cursor-pointer transition-colors min-h-touch-lg ${
        selected
          ? 'bg-[var(--ludi-sel-on)] border-[var(--ludi-bdr-a)]'
          : 'bg-ludi-sf border-[var(--ludi-bdr-m)] hover:border-[var(--ludi-bdr-a)]'
      } ${className}`}
    >
      {title && <p className="text-ludi-base font-semibold text-ludi-t100">{title}</p>}
      {subtitle && <p className="text-ludi-sm text-ludi-t60 mt-ludi-1">{subtitle}</p>}
      {children}
    </button>
  );
}
